import { SecRayonType } from "../types/commercial";

export const useSectorOptions = (
  listValue: Array<{ item: Array<SecRayonType> }>,
  type: string
) => {
  const sectorsSet = new Set();

  listValue?.slice(1).forEach((group) => {
    group.item?.forEach((elt) => {
      sectorsSet.add(elt.sector);
    });
  });

  let sectorOptions = Array.from(sectorsSet).map((sector, index) => ({
    label:
      sector === "SDV" || sector === "SERVICES"
        ? sector
        : (("   " + sector) as string),
    value: type === "num" ? (index + 1).toString() : (sector as string),
  }));

  sectorOptions.unshift({ label: "SDV", value: type === "num" ? "0" : "SDV" });

  return sectorOptions;
};
